import script from "./NestedNavItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NestedNavItem.vue?vue&type=script&setup=true&lang=ts"

import "./NestedNavItem.vue?vue&type=style&index=0&id=4bbf044f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bbf044f"]])

export default __exports__